import {
  Grid,
  TextField,
  TableCell,
  Table,
  TableBody,
  TableRow
} from '@material-ui/core';
import React, { Component } from 'react';
import store from '../../store/appStore';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import _, { cloneDeep } from 'lodash';
import Reports from './Reports';
import { Switch } from '../common/Switch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import './report.less';
import moment from 'moment';
import { DateFormat, DOWNLOAD_DATA_MESSAGE } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import AdvancedFilter from './AdvancedFilter';
import {
  GenerateAbsoluteURL,
  getCurrentPayCycleEndDateByDate,
  getCurrentPayCycleStartDateByDate,
  removeDuplicates,
  disableDatesForPayCycleStart1,
  disableDatesForPayCycleEnd1,
  getNumberOfPayCycle,
  IsSensitiveDataAccess,
  getMaxDate,
  EnhancedTableHead,
  orderBy,
  getPreviousPayCycle,
  IsAutoRunPagesEnabled
} from '../../utils/helper';
import { getFormattedValues, getFormattedValuesForReport } from '../../utils/formatData';
import { getMultilevelGroupedData } from '../../utils/generic';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import { collapsableAllocationPercent, collapsableReimbursement, extendibleMarketArray } from '../../constants/MockData';
import TableWithPaginations from './TableWithPaginations';
import PageLandingMessage from '../common/PageLandingMessage/PageLandingMessage'

let defaultPayPeriod = [];
const rowrender = { count: 0 };

export default class PropertyReimbursementReport extends Component {
  // Constructor
  constructor(props) {
    super(props);
    const { user } = store.getState();
    this.state = {
      showMain: false,
      propertyTypeMasterData: [],
      serviceTypeMasterData: [],
      employeeMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      legalEntityMasterData: [],
      expenseGroupMasterData: [],
      expenseNameMasterData: [],
      accountCodeNameMasterData: [],      
      payPeriodStartDate: getPreviousPayCycle().previousPayCycleStartDate,
      payPeriodEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      futureEndDate: getCurrentPayCycleEndDateByDate(moment().format(DateFormat)),
      maxEndDate: getPreviousPayCycle().previousPayCycleEndDate,
      propertyReimburseData: [],
      rows: [],
      showReport: false,
      clientListingMasterData: [],
      market: [{ marketName: 'All' }],
      property: [{ propertyName: 'All' }],
      propertyType: [{ propertyTypeName: 'All' }],
      service: [{ serviceType: 'All' }],
      department: [{ departmentName: 'All' }],
      employee: [{ employeeName: 'All' }],
      SupervisorEmployee: [{ employeeName: 'All' }],
      supervisorEmployeeMasterData: [],
      client: [{ clientName: 'All' }],
      legalEntity: [{ customerName: 'All' }],
      expenseGroup: [{ expenseGroup: 'All' }],
      expenseName: [{ expenseName: 'All' }],
      accountCode: [{ accountCode: 'All' }],
      openSlidingPanel: false,
      printPage: false,
      payPeriod: [],
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Client',
              value: 'client',
              id: 'client',
              ssrsReport: 'Client',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text',
              order: 2
            },
            {
              key: 'Legal Entity',
              id: 'legalEntity',
              value: 'legalEntity',
              ssrsReport: 'LegalEntity',
              numeric: false,
              disablePadding: false,
              label: 'Legal Entity',
              type: 'Text',
              order: 3
            },
            {
              key: 'Service Type',
              value: 'serviceType',
              id: 'serviceType',
              ssrsReport: 'ServiceType',
              numeric: false,
              disablePadding: false,
              label: 'Service Type',
              type: 'Text',
              order: 4
            },
            {
              key: 'Property Name',
              value: 'propertyName',
              id: 'propertyName',
              ssrsReport: 'PropertyName',
              numeric: false,
              disablePadding: false,
              label: 'Client',
              type: 'Text',
              order: 5
            },
            {
              key: 'Property Type',
              value: 'propertyType',
              id: 'propertyType',
              ssrsReport: 'PropertyType',
              numeric: false,
              disablePadding: false,
              label: 'Property Type',
              type: 'Text',
              order: 6
            },
            {
              key: 'Property Sub Type',
              value: 'propertySubType',
              id: 'propertySubType',
              ssrsReport: 'PropertySubType',
              numeric: false,
              disablePadding: false,
              label: 'Property Sub Type',
              type: 'Text',
              order: 7
            },
            {
              key: 'Account Code Name',
              value: 'accountCode',
              id: 'accountCode',
              ssrsReport: 'AccountCode',
              numeric: false,
              disablePadding: false,
              label: 'Account Code Name',
              type: 'Text',
              order: 8
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 9
            },
            {
              key: 'Expense Group',
              value: 'expenseGroup',
              id: 'expenseGroup',
              ssrsReport: 'ExpenseGroup',
              numeric: false,
              disablePadding: false,
              label: 'Expense Group',
              type: 'Text',
              order: 10
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text',
              order: 11
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'Market',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true,
        startDate: getPreviousPayCycle().previousPayCycleStartDate,
        endDate: getPreviousPayCycle().previousPayCycleEndDate
      },
      summaryCols: ['reimbursementCost'],
      expand: false,
      openDialog: false,
      dialogTitle: null,
      confirmationMessage: '',
      handleCollapse: false,
      order: 'asc',
      orderBy: 'nam',
      showTrueUpCredit: false,
      showSingleTotal: false,
      isAutoRunEnabled: IsAutoRunPagesEnabled(),
      isSubmitButtonClicked: false,
      downloadMessage: null,
      isUnlimitedPayCyclesEnabled: (user.userData || {})?.isUnlimitedPayPeriodsEnabledForReports || false,
      noOfAllowedPayPeriodsForReports: (user.userData || {})?.noOfAllowedPayPeriodsForReports || 12,
      noOfAllowedPayPeriodsForReportsUI: (user.userData || {})?.NoOfAllowedPayPeriodsForReportsUI || 4,
      noOfMarketsInSingleRequestForReimbursement: (user.userData || {})?.noOfMarketsInSingleRequestForReimbursement || 0
    };

    this.baseState = this.state;
  }

  // This method is used to get master data by calling APIs before component is mounted
  componentDidMount() {
    this.loadData();
  }

  // Click event of Back button, It will navigate to Reports list view
  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  // Open Panel
  handleClickOpen = () => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    localStorage.setItem('selectedendDate', this.state.payPeriodEndDate);
    this.setState({
      openSlidingPanel: true
    });
  };

  // Date change event of calendar. When Start Date is selected, it will set End Date as Start Date + 2 pay periods.
  handleDateChange = (date, name) => {    
    let { advanceFilterConfig, payPeriodEndDate, noOfAllowedPayPeriodsForReports } = this.state;    
    let formattedDate = moment(date).format(DateFormat);
    if (formattedDate !== 'Invalid date') {
      const count = getNumberOfPayCycle(formattedDate, payPeriodEndDate);
      let futureEndDate = getMaxDate(formattedDate);
      if (count > 2) {
        payPeriodEndDate = futureEndDate;
      }
      if (name === 'payPeriodStartDate') {
        formattedDate = getCurrentPayCycleStartDateByDate(formattedDate).format(DateFormat);
        advanceFilterConfig.startDate = formattedDate;
        futureEndDate = moment(getCurrentPayCycleEndDateByDate(moment(formattedDate).add((noOfAllowedPayPeriodsForReports/2), 'M').subtract(1, 'days').format('MM/DD/YYYY'))).format('MM/DD/YYYY');
        this.setState({
          [name]: formattedDate,
          futureEndDate: (this.state.isUnlimitedPayCyclesEnabled === true ? undefined : futureEndDate),      
          payPeriodEndDate: payPeriodEndDate //futureEndDate
        });
      } else {
        formattedDate = getCurrentPayCycleEndDateByDate(date).format(DateFormat);
        advanceFilterConfig.endDate = formattedDate;

        this.setState({
          [name]: formattedDate
        });
      }
    }
  };

  // Disable other dates  except pay cycle start dates (i.e. Excluding 1 & 16) on Pay Cycle Start calendar 
  disableDatesForPayCycleStart = (date) => {
    return disableDatesForPayCycleStart1(date);
  }

  // Disable other date except pay cycle end dates (i.e. excluding mid and last day of the month) on Pay Cycle End calendar
  disableDatesForPayCycleEnd = (date) => {
    return disableDatesForPayCycleEnd1(date);
  }

  // Close sliding panel of calendar
  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  // Reset all selected filters and reload data
  resetPage = () => {
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.summaryRows = true;
    advanceFilterConfig.suppressZero = true;
    advanceFilterConfig.suppressDetails = false;
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Client',
          value: 'client',
          id: 'client',
          ssrsReport: 'Client',
          numeric: false,
          disablePadding: false,
          label: 'Client',
          type: 'Text',
          order: 2
        },
        {
          key: 'Legal Entity',
          id: 'legalEntity',
          value: 'legalEntity',
          ssrsReport: 'LegalEntity',
          numeric: false,
          disablePadding: false,
          label: 'Legal Entity',
          type: 'Text',
          order: 3
        },
        {
          key: 'Service Type',
          value: 'serviceType',
          id: 'serviceType',
          ssrsReport: 'ServiceType',
          numeric: false,
          disablePadding: false,
          label: 'Service Type',
          type: 'Text',
          order: 4
        },
        {
          key: 'Property Name',
          value: 'propertyName',
          id: 'propertyName',
          ssrsReport: 'PropertyName',
          numeric: false,
          disablePadding: false,
          label: 'Client',
          type: 'Text',
          order: 5
        },
        {
          key: 'Property Type',
          value: 'propertyType',
          id: 'propertyType',
          ssrsReport: 'PropertyType',
          numeric: false,
          disablePadding: false,
          label: 'Property Type',
          type: 'Text',
          order: 6
        },
        {
          key: 'Property Sub Type',
          value: 'propertySubType',
          id: 'propertySubType',
          ssrsReport: 'PropertySubType',
          numeric: false,
          disablePadding: false,
          label: 'Property Sub Type',
          type: 'Text',
          order: 7
        },
        {
          key: 'Account Code Name',
          value: 'accountCode',
          id: 'accountCode',
          ssrsReport: 'AccountCode',
          numeric: false,
          disablePadding: false,
          label: 'Account Code Name',
          type: 'Text',
          order: 8
        },
        {
          key: 'Employee',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'Employee',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 9
        },
        {
          key: 'Expense Group',
          value: 'expenseGroup',
          id: 'expenseGroup',
          ssrsReport: 'ExpenseGroup',
          numeric: false,
          disablePadding: false,
          label: 'Expense Group',
          type: 'Text',
          order: 10
        },
        {
          key: 'Expense Name',
          value: 'expenseName',
          id: 'expenseName',
          ssrsReport: 'ExpenseName',
          numeric: false,
          disablePadding: false,
          label: 'Expense Name',
          type: 'Text',
          order: 11
        }],
      selected: [{
        key: 'Market',
        value: 'marketName',
        id: 'marketName',
        ssrsReport: 'Market',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]

    };
    this.setState({
      ...this.baseState,
      isSubmitButtonClicked: false,
      downloadMessage: null,
      advanceFilterConfig
    });
    this.loadData();
  };

  // Click event of Submit button
  // It validates the filtered data and get Property Reimbursement Report Data
  handleSubmit = () => {
    const {market} = this.state;
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const { fromDate, toDate } = this.getPayCyclesFromState();
    const count = getNumberOfPayCycle(fromDate, toDate);
    if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
      const message = 'You can select maximum ' + this.state.noOfAllowedPayPeriodsForReports + ' paycycles';
      ShowToast(
        message,
        toastType.WARNING,
        5000,
        500
      );
    } else {
      if (count > this.state.noOfAllowedPayPeriodsForReportsUI && marketId.join('|') === '') {
        const message = 'You have selected All Markets and more than ' + this.state.noOfAllowedPayPeriodsForReportsUI?.toString() + ' Pay Periods. \nThe Data will be exported into Excel instead of displaying on the screen due to high volume. \nDo you want continue to export?';
        
        this.setState({
          openDialog: true,
          dialogTitle: 'Download to Excel',
          fileMimeType: 'application/vnd.ms-excel',
          type: 'Excel',
          isPrint: false,
          confirmationMessage: message
        });
      } else {
        this.GetPropertyReimburseData();
      }
    }
  };

  // Print report button click event. It will open the report into another tab of browser in pdf format for print
  handlePrintClick = () => {    
    this.handleExport('application/pdf', 'Pdf', true);
  };

  // Get Property Reimbursement report data based on selected filters
  GetPropertyReimburseData = () => {
    const {
      market,
      property,
      propertyType,
      service,
      employee,
      client,
      legalEntity,
      payPeriodStartDate,
      payPeriodEndDate,
      expenseGroup,
      expenseName,
      accountCode,
      SupervisorEmployee,
      showTrueUpCredit,
      showSingleTotal,
      marketMasterData,
      noOfMarketsInSingleRequestForReimbursement
    } = this.state;
    
    let marketId = _.cloneDeep(market.map((x) => x.marketId));
    if(noOfMarketsInSingleRequestForReimbursement > 0) {
      if(marketId.join('|') === '') {
        marketId = marketMasterData.filter(x => x.marketId).map(x=> x.marketId);
      }
    }
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
    const propertyTypeId = _.cloneDeep(
      propertyType.map((x) => x.propertyTypeId)
    );
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));
    const serviceTypeId = _.cloneDeep(service.map((x) => x.serviceTypeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const accountCodeId = _.cloneDeep(accountCode.map((x) => x.accountCodeId));

    const fromDate =
      payPeriodStartDate == null
        ? getCurrentPayCycleStartDateByDate(moment())
        : payPeriodStartDate;
    const toDate =
      payPeriodEndDate == null
        ? getCurrentPayCycleEndDateByDate(moment())
        : payPeriodEndDate;

    const params = {
      payPeriodStartDate: moment(fromDate).format(DateFormat),
      payPeriodEndDate: moment(toDate).format(DateFormat),
      // marketId: marketId.join('|'),
      propertyId: propertyId.join('|'),
      propertyTypeId: propertyTypeId.join('|'),
      serviceTypeId: serviceTypeId.join('|'),
      employeeId: employeeId.join('|'),
      clientId: clientId.join('|'),
      legalEntityId: legalEntityId.join('|'),
      expenseGroupId: expenseGroupId.join('|'),
      expenseNameId: expenseNameId.join('|'),
      accountCodeId: accountCodeId.join('|'),
      supervisorId: supervisorId.join('|'),
      showTrueUpCredit: showTrueUpCredit,
      showSingleTotal: showSingleTotal
    };

    let dataUrl = [];
    let reqCount = 0;
    if(noOfMarketsInSingleRequestForReimbursement > 0) {
      reqCount = Math.ceil(marketId.length / noOfMarketsInSingleRequestForReimbursement);
      for (let i = 0; i < reqCount; i++) {
        params.marketId = marketId.slice(i*noOfMarketsInSingleRequestForReimbursement, (i+1) * noOfMarketsInSingleRequestForReimbursement).join('|');  
        dataUrl.push({
          url: API_URL.Report.GetPropertyReimburseData,
          params: cloneDeep(params),
          key: 'propertyReimburseData'+ i
        })    
      }
      // marketId.forEach(market => {
      //   params.marketId = market;  
      //   dataUrl.push({
      //     url: API_URL.Report.GetPropertyReimburseData,
      //     params: cloneDeep(params),
      //     key: 'propertyReimburseData'+ market
      //   })    
      // });
    } else {
      reqCount = 1;
      params.marketId = marketId.join('|');  
      dataUrl.push({
        url: API_URL.Report.GetPropertyReimburseData,
        params: cloneDeep(params),
        key: 'propertyReimburseData0'
      })
    }

    this._asyncRequest = apiBatchRequest(dataUrl)
      .then((res) => {
        // console.log(res);
        this._asyncRequest = null;        
        let propertyReimburseDataValue = [];
        for (let i = 0; i < reqCount; i++) {
          if (res['propertyReimburseData'+ i].success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          propertyReimburseDataValue = [...propertyReimburseDataValue, ...res['propertyReimburseData'+ i].data];
        }
        // marketId.forEach(market => {
        //   if (res['propertyReimburseData'+ market].success !== true) {
        //     ShowToast(
        //       commonLabels.somethingWrong,
        //       toastType.ERROR,
        //       5000,
        //       500,
        //       'Server error'
        //     );
        //   }
        //   propertyReimburseDataValue = [...propertyReimburseDataValue, ...res['propertyReimburseData'+ market].data];
        // })

        // data = [...data, ...propertyReimburseData.data];
        // propertyReimburseDataValue = [...propertyReimburseDataValue, ...propertyReimburseData.data]; // propertyReimburseData.data || [];
        // const payPeriod = propertyReimburseDataValue.length > 0
        //   ? _.chain(propertyReimburseDataValue[0].reimbursmentDetails).groupBy('payPeriod')
        //     .map(function (_des, desi) {
        //       return {
        //         payPeriod: desi,
        //         isCollapsed: true
        //       };
        //     })
        //     .value()
        //   : [];
        // defaultPayPeriod = payPeriod;
        let payCycles = [];
        (propertyReimburseDataValue || []).forEach(
          d => d.reimbursmentDetails.forEach(
              r => {
                if(payCycles.includes(r.payPeriod) === false) {
                  payCycles.push(r.payPeriod);
                }
              } 
          )
        );
        payCycles = _.orderBy(removeDuplicates(payCycles));
        const payPeriods = (payCycles || []).map(p => {
          return {
            payPeriod: p,
            isCollapsed: true
          };
        })
        defaultPayPeriod = payPeriods;

        const rows = this.getTableRow(propertyReimburseDataValue);
        this.setState({
          propertyReimburseData: propertyReimburseDataValue,
          rows,
          originalPropertyReimbursementData: propertyReimburseDataValue,
          showReport: true,
          isSubmitButtonClicked: true,
          payPeriod: payPeriods,
          expand: false,
          downloadMessage: null
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });

    // this._asyncRequest = apiBatchRequest([
    //   {
    //     url: API_URL.Report.GetPropertyReimburseData,
    //     params,
    //     key: 'propertyReimburseData'
    //   }
    // ])
    //   .then(({ propertyReimburseData }) => {
    //     this._asyncRequest = null;
    //     if (propertyReimburseData.success !== true) {
    //       ShowToast(
    //         commonLabels.somethingWrong,
    //         toastType.ERROR,
    //         5000,
    //         500,
    //         'Server error'
    //       );
    //     }
    //     const propertyReimburseDataValue = propertyReimburseData.data || [];
    //     // const payPeriod = propertyReimburseDataValue.length > 0
    //     //   ? _.chain(propertyReimburseDataValue[0].reimbursmentDetails).groupBy('payPeriod')
    //     //     .map(function (_des, desi) {
    //     //       return {
    //     //         payPeriod: desi,
    //     //         isCollapsed: true
    //     //       };
    //     //     })
    //     //     .value()
    //     //   : [];
    //     // defaultPayPeriod = payPeriod;
    //     let payCycles = [];
    //     (propertyReimburseDataValue || []).forEach(
    //       d => d.reimbursmentDetails.forEach(
    //           r => {
    //             if(payCycles.includes(r.payPeriod) === false) {
    //               payCycles.push(r.payPeriod);
    //             }
    //           } 
    //       )
    //     );
    //     payCycles = _.orderBy(removeDuplicates(payCycles));
    //     const payPeriods = (payCycles || []).map(p => {
    //       return {
    //         payPeriod: p,
    //         isCollapsed: true
    //       };
    //     })
    //     defaultPayPeriod = payPeriods;

    //     const rows = this.getTableRow(propertyReimburseDataValue);
    //     this.setState({
    //       propertyReimburseData: propertyReimburseDataValue,
    //       rows,
    //       originalPropertyReimbursementData: propertyReimburseDataValue,
    //       showReport: true,
    //       isSubmitButtonClicked: true,
    //       payPeriod: payPeriods,
    //       expand: false
    //     });
    //   })
    //   .catch(() => {
    //     this._asyncRequest = null;
    //   });
  };

  // Render table cell with formatted data
  renderTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
    let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
    let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
    let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';
    let column7 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[6]?.value) || {}).value ?? '' : '';
    let column8 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[7]?.value) || {}).value ?? '' : '';
    let column9 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[8]?.value) || {}).value ?? '' : '';
    let column10 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[9]?.value) || {}).value ?? '' : '';
    let column11 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[10]?.value) || {}).value ?? '' : '';
    
    const payPeriod = defaultPayPeriod;
    
    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {        
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(cloneDeep(currentGroupedRow));
      
      if (d.reimbursmentDetails) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        const key = rowCount + '_' + i;
        if (d.reimbursmentDetails.length > 0 && (d.reimbursmentDetails[0].isSummary === undefined ||
          (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
            this.state.advanceFilterConfig.summaryRows === true))) {
          if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
            tableCell.push(
              <TableRow                
                className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
              >{(!suppressDetails || (suppressDetails && sequence[0]?.value !== '')) && (
                <TableCell
                  className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                    ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                    ? topBorderClass
                    : '')}
                >
                  {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')
                  }{' '}
                </TableCell>
              )
                }
                {(!suppressDetails || (suppressDetails && sequence[1]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-1 ' +
                      evenOddClass +
                      (column2 !== d[sequence[1]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                      : (getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text') === null ? <span className='total-count'>-</span> : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text'))}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[2]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-2 ' +
                      evenOddClass +
                      (column3 !== d[sequence[2]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                      : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[3]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-3 ' +
                      evenOddClass +
                      (column4 !== d[sequence[3]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                      : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[4]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-4 ' +
                      evenOddClass +
                      (column5 !== d[sequence[4]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                      : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[5]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-5 ' +
                      evenOddClass +
                      (column6 !== d[sequence[5]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                      : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[6]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-6 ' +
                      evenOddClass +
                      (column7 !== d[sequence[6]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[6]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[6]?.value)}</span>
                      : getFormattedValues(column7 !== d[sequence[6]?.value] && d[sequence[6]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[7]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-7 ' +
                      evenOddClass +
                      (column8 !== d[sequence[7]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[7]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[7]?.value)}</span>
                      : getFormattedValues(column8 !== d[sequence[7]?.value] && d[sequence[7]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[8]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-8 ' +
                      evenOddClass +
                      (column9 !== d[sequence[8]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[8]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[8]?.value)}</span>
                      : getFormattedValues(column9 !== d[sequence[8]?.value] && d[sequence[8]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[9]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-9 ' +
                      evenOddClass +
                      (column10 !== d[sequence[9]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[9]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[9]?.value)}</span>
                      : getFormattedValues(column10 !== d[sequence[9]?.value] && d[sequence[9]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[10]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-10 ' +
                      evenOddClass +
                      (column11 !== d[sequence[10]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[10]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >                    
                    {d.isGroup === true && getFormattedValues(column11 !== d[sequence[10]?.value] && d[sequence[10]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[10]?.value)}</span>
                      : getFormattedValues(column11 !== d[sequence[10]?.value] && d[sequence[10]?.value], 'Text')}
                  </TableCell>
                )
                }
                {payPeriod?.map((date, ind) => (
                  this.renderReimbursementColumn(d.reimbursmentDetails, date, key + ind, evenOddClass, d)
                ))}
              </TableRow>
            );
          }
        }
        rowCount++;
        rowrender.count++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
        column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
        column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
        column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
        column7 = (keyvalue.find(x => x.key === sequence[6]?.value) || {}).value ?? '';
        column8 = (keyvalue.find(x => x.key === sequence[7]?.value) || {}).value ?? '';
        column9 = (keyvalue.find(x => x.key === sequence[8]?.value) || {}).value ?? '';
        column10 = (keyvalue.find(x => x.key === sequence[9]?.value) || {}).value ?? '';
        column11 = (keyvalue.find(x => x.key === sequence[10]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
        this.renderTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });
    return tableCell;
  };

  // Expand pay period details. Show pay period wise other columns along with Amount columns
  expandAll = (e) => {
    const collapsePayPeriod = (this.state.payPeriod || []);

    (collapsePayPeriod.filter(d => d.isCollapsed === e.target.checked) || []).forEach((x) => {
      x.isCollapsed = !e.target.checked;
    });
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getTableRow(this.state.propertyReimburseData || []);
    this.setState({
      expand: e.target.checked,
      payPeriod: collapsePayPeriod,
      rows
    });
  }

  // Render pay period wise Reimbursement columns
  renderReimbursementColumn = (reimbursementDetails, payPeriod, index, evenOddClass, d) => {
    const reimbursementDetail = reimbursementDetails.filter(x => moment(x.payPeriod).format(DateFormat) === moment(payPeriod.payPeriod).format(DateFormat));
    const tableCell = [];
    const isSensitiveData = IsSensitiveDataAccess();
    const collapsableObj = isSensitiveData ? collapsableReimbursement : collapsableAllocationPercent;
    const extendibleArray = isSensitiveData ? extendibleMarketArray : extendibleMarketArray.filter(x => (x.key !== 'allocationRate' && x.key !== 'expenseAmount' && x.key !== 'burdenAmount'));
    tableCell.push(<>
      {payPeriod.isCollapsed === false && (
        <>
          {
            extendibleArray.map((obj, i) => (
              <TableCell className={(evenOddClass + 'rpt-topBorder')} key={obj.key + i}>
                {
                  reimbursementDetail.map((reimburse, ind) =>
                    <div
                      key={index + obj.key + i + ind} className={((reimbursementDetail.length) > 1 && ind !== (reimbursementDetail.length - 1))
                        ? 'multi-pay-period'
                        : ''}>
                      {d.isGroup === true && obj.format === 'DecimalPercent' && reimburse[obj.key] === undefined
                        ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse[obj.key])}</span>
                        : reimburse[obj.key] === null
                          ? <span className="number-text"></span>
                          : getFormattedValuesForReport(reimburse[obj.key], obj.format, obj.appendText)}
                    </div>
                  )
                }
              </TableCell>
            ))
          }
        </>)
      }
      <TableCell className={(evenOddClass + 'right-border  rpt-topBorder')} key={index + collapsableObj.key}>
        {
          reimbursementDetail.map((reimburse, ind) =>
            <div
              key={index + collapsableObj.key + ind} className={((reimbursementDetail.length) > 1 && ind !== (reimbursementDetail.length - 1))
                ? 'multi-pay-period'
                : ''}>
              {d.isGroup === true && collapsableObj.format === 'DecimalPercent' && reimburse[collapsableObj.key] === undefined
                ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse[collapsableObj.key])}</span>
                : reimburse[collapsableObj.key] === null
                  ? <span className="number-text">-</span>
                  : getFormattedValuesForReport(reimburse[collapsableObj.key], collapsableObj.format, collapsableObj.appendText)}</div>
          )
        }
      </TableCell>
    </>);
    return tableCell;
  }

  // Render row of table
  renderTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    console.log('render started'+ new Date());
    const cellData =  this.renderTableCell(
      getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true),
      []);
    console.log('render Ended'+ new Date(), cellData);
    return cellData;
  };

  // Get table data row wise
  getTableRow = (propertyReimburseData) => {
    let returnRows = [];

    returnRows = [...returnRows, ...this.renderTableRow(
      orderBy(propertyReimburseData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  // Handle sorting of column data in ascending and descending order
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.renderTableRow(
      orderBy((this.state.propertyReimburseData || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => { this.forceUpdate(); });
  };

  // Expand/Collapse Reimbursement columns of selected pay period
  onClickOnArrow = (payPeriod, isCollapsed) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    collapsePayPeriod.find(d => d.payPeriod === payPeriod).isCollapsed = !isCollapsed;
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getTableRow(this.state.propertyReimburseData || []);
    this.setState({
      payPeriod: collapsePayPeriod,
      handleCollapse: !this.state.handleCollapse,
      rows
    }, () => { this.forceUpdate(); });
  }

  // Render report table with formatted data
  renderTable = (rows) => {
    const { payPeriod, showSingleTotal, payPeriodStartDate, payPeriodEndDate } = this.state;
    const groupSequence = this.getColumnSequence();    
    const suppressColumns = this.getSupprssDetailsColumnCount();
    const isSensitiveData = IsSensitiveDataAccess();
    const collapsableObj = isSensitiveData ? collapsableReimbursement : collapsableAllocationPercent;
    const extendibleArray = isSensitiveData ? extendibleMarketArray : extendibleMarketArray.filter(x => (x.key !== 'allocationRate' && x.key !== 'expenseAmount' && x.key !== 'burdenAmount' && x.key !== 'flatrate'));
    const formattedPayPeriod = showSingleTotal === true ? (moment(payPeriodStartDate).format('MM-DD-YYYY') + ' to '+ moment(payPeriodEndDate).format('MM-DD-YYYY')) : null;
    return (
      <Table className="reportTable" id="rptTable" key="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length} // {propertyReimburseData.length}
          columnSequence={groupSequence}
          headCells={[]}
          payPeriod={payPeriod}
          formattedPayPeriod={formattedPayPeriod}
          isSensitiveData={isSensitiveData}
          dynamicColumnCount={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          suppressDetailsColumnCount={suppressColumns}
          extendibleArray={extendibleArray}
          collapsableObj={collapsableObj}
          onClickOnArrow={this.onClickOnArrow}
          expand={this.state.expand}
          expandAll={this.expandAll}
          suppressDetails={this.state.advanceFilterConfig.suppressDetails}
        />
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  // Click event of switch button "Show Detailed TrueUp/Credit Records". 
  // It will set true/false value to the variable showTrueUpCredit
  // If the value is true, it will show pay period wise trueUp/Credit records
  // If the value is false, it will show Employee and Property wise summarized TrueUp/Credit records
  isAcceptCondition = (checked) => {
    this.setState({ showTrueUpCredit: checked });
  }

  // Handle change event of filter values
  handleChange = (e, value, name, optionLabel) => {
    if (name !== null) {
      if ((this.state[name] || []).find(x => x[optionLabel] === 'All') === undefined) {
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
          this.setState({ [name]: value });
        } else if ((value || []).find(x => x[optionLabel] === 'All')) {
          this.setState({ [name]: [{ [optionLabel]: 'All' }] });
        } else {
          this.setState({ [name]: value });
        }
      } else {
        value = (value || []).filter(x => x[optionLabel] !== 'All');
        if (value && value.length === 0) {
          value = [{ [optionLabel]: 'All' }];
        }
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: e.target.value });
    }
  };
  
  // Get Suppress detail column counts
  getSupprssDetailsColumnCount = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      const columns = [];
      const allColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
      const selectedColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
      const diffColumns = allColumns.length - selectedColumns.length;
      for (let c = 0; c < diffColumns; c++) {
        columns.push(c + 1);
      }
      return columns;
    } else {
      return [];
    }
  }

  // Get count of grouped columns
  getGroupColumnCount = () => {
    const groupColumns = this.getColumnSequence()?.length;
    const columns = [];
    if (groupColumns > 0) {
      for (let c = 0; c < groupColumns?.length; c++) {
        columns.push(c + 1);
      }
    } else {
      return [];
    }
  }

  // Get grouped column's sequence to display report in selected sequences with grouped data
  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
    }
  }

  // Adjust column sequene when selected/deselected from grouping in Advance filter
  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  // Event occurs when advanced filter values are changed
  onAddvanceFilterChange = (advanceFilterConfig) => {
    localStorage.setItem('selectedstartDate', this.state.payPeriodStartDate);
    localStorage.setItem('selectedendDate', this.state.payPeriodEndDate);
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false,
      orderBy: advanceFilterConfig?.groupBy?.selected.length > 0
        ? advanceFilterConfig?.groupBy?.selected[0]?.value
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? advanceFilterConfig?.groupBy?.masterData[0]?.value : this.state.orderBy),
      order: advanceFilterConfig?.groupBy?.selected.length > 0
        ? 'asc'
        : (advanceFilterConfig?.groupBy?.masterData[0]?.value !== undefined ? 'asc' : this.state.order)
    }, () => this.handleSubmit()); // this.GetPropertyReimburseData());
  }

  getGroupedArray(d, key) {
    return '';
  }

  // Get selected pay period Start and End date from state 
  getPayCyclesFromState() {
    const {
      payPeriodStartDate, payPeriodEndDate
    } = this.state;
    const fromDate = payPeriodStartDate == null
      ? getCurrentPayCycleStartDateByDate(moment())
      : payPeriodStartDate;
    const toDate = payPeriodEndDate == null
      ? getCurrentPayCycleEndDateByDate(moment())
      : payPeriodEndDate;
    return { fromDate, toDate };
  }

  // Event to check validations and export report in pdf or excel format.
  handleExport = (fileMimeType, type, isPrint) => {
    const { showSingleTotal } = this.state;
    const { fromDate, toDate } = this.getPayCyclesFromState();
    const count = getNumberOfPayCycle(fromDate, toDate);
    if (this.state.isUnlimitedPayCyclesEnabled !== true && count > this.state.noOfAllowedPayPeriodsForReports) {
      const message = 'You can select maximum '+ this.state.noOfAllowedPayPeriodsForReports +' paycycles';
      ShowToast(
        message,
        toastType.WARNING,
        5000,
        500
      );
    } else {
      if (type.toLowerCase() === 'PDF'.toLowerCase()) {
        if (showSingleTotal === false && count > 1) {
          let message = 'PDF is not a suitable option to show these many pay cycles. This will lead to distorted UI in the PDF. Either go for the excel option in order to view the data. Still, do you want to continue?';
          if (isPrint) {
            message = 'PDF is not a suitable option to show these many pay cycles. This will lead to distorted UI in the PDF. Either go for the excel option in order to view the data. Still, do you want to continue?';
          }
          this.setState({
            openDialog: true,
            dialogTitle: null,
            fileMimeType,
            type,
            isPrint,
            confirmationMessage: message
          });
        } else {
          this.downloadFile(fileMimeType, type, isPrint);
        }
      } else {
        this.downloadFile(fileMimeType, type, isPrint);
      }
    }
  }

  // Dialog box confirm button handling
  onConfirmClickHandle = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
        propertyReimburseData: [],
        rows:[],
        originalPropertyReimbursementData: [],
        showReport: true,
        downloadMessage: DOWNLOAD_DATA_MESSAGE,
        isSubmitButtonClicked: true
      }, () => {this.downloadFile(this.state.fileMimeType, this.state.type, this.state.isPrint)});
    } else {
      this.setState({
        openDialog: false
      });
    }
  }

  // Download SSRS report in selected formats like pdf or excel
  downloadFile = (fileMimeType, type, isPrint) => {
    const {
      market,
      property,
      propertyType,
      service,
      client,
      legalEntity,
      payPeriodStartDate,
      payPeriodEndDate,
      advanceFilterConfig,
      department,
      employee,
      expenseGroup,
      expenseName,
      accountCode,
      SupervisorEmployee,
      showTrueUpCredit,
      showSingleTotal
    } = this.state;
    const dataValue = [
      { key: 'StartDate', value: moment(payPeriodStartDate).format(DateFormat) },
      { key: 'EndDate', value: moment(payPeriodEndDate).format(DateFormat) }
    ];
    const marketId = _.cloneDeep(market.map((x) => x.marketId));
    const serviceTypeId = _.cloneDeep(service.map((x) => x.serviceTypeId));
    const clientId = _.cloneDeep(client.map((x) => x.clientId));
    const legalEntityId = _.cloneDeep(legalEntity.map((x) => x.customerId));
    const propertyId = _.cloneDeep(property.map((x) => x.propertyId));
    const propertyTypeId = _.cloneDeep(propertyType.map((x) => x.propertyTypeId));
    const employeeId = _.cloneDeep(employee.map((x) => x.employeeId));
    const expenseGroupId = _.cloneDeep(expenseGroup.map((x) => x.expenseGroupId));
    const expenseNameId = _.cloneDeep(expenseName.map((x) => x.expenseNameId));
    const accountCodeId = _.cloneDeep(accountCode.map((x) => x.accountCodeId));

    dataValue.push({ key: 'MarketId', value: (marketId.join('|') === undefined || marketId.join('|') === '') ? '0' : marketId.join('|') });
    dataValue.push({ key: 'ServiceTypeId', value: (serviceTypeId.join('|') === undefined || serviceTypeId.join('|') === '') ? '0' : serviceTypeId.join('|') });
    dataValue.push({ key: 'ClientId', value: (clientId.join('|') === undefined || clientId.join('|') === '') ? '0' : clientId.join('|') });
    dataValue.push({ key: 'LegalentityId', value: (legalEntityId.join('|') === undefined || legalEntityId.join('|') === '') ? '0' : legalEntityId.join('|') });
    dataValue.push({ key: 'PropertyId', value: (propertyId.join('|') === undefined || propertyId.join('|') === '') ? '0' : propertyId.join('|') });
    dataValue.push({ key: 'PropertyTypeId', value: (propertyTypeId.join('|') === undefined || propertyTypeId.join('|') === '') ? '0' : propertyTypeId.join('|') });
    dataValue.push({ key: 'EmployeeId', value: (employeeId.join('|') === undefined || employeeId.join('|') === '') ? '0' : employeeId.join('|') });
    dataValue.push({ key: 'ExpenseGroupId', value: (expenseGroupId.join('|') === undefined || expenseGroupId.join('|') === '') ? '0' : expenseGroupId.join('|') });
    dataValue.push({ key: 'ExpenseNameId', value: (expenseNameId.join('|') === undefined || expenseNameId.join('|') === '') ? '0' : expenseNameId.join('|') });
    dataValue.push({ key: 'AccountCodeId', value: (accountCodeId.join('|') === undefined || accountCodeId.join('|') === '') ? '0' : accountCodeId.join('|') });

    dataValue.push({ key: 'ShowSensitiveData', value: IsSensitiveDataAccess() });
    dataValue.push({ key: 'SuppressZero', value: advanceFilterConfig.suppressZero === true ? 1 : 0 });
    // dataValue.push({ key: 'SuppressDetail', value: advanceFilterConfig.suppressDetails === true ? 1 : 0 });
    const supervisorId = _.cloneDeep(SupervisorEmployee.map((x) => x.ultiProEmployeeId));

    if (supervisorId && supervisorId.length > 0) {
      dataValue.push({ key: 'supervisorId', value: supervisorId.join('|') === undefined ? '' : supervisorId.join('|') });
    }
    dataValue.push({ key: 'ShowTrueUpCredit', value: showTrueUpCredit });
    dataValue.push({ key: 'ShowTotalColumn', value: showSingleTotal });
    let url = '';
    if (advanceFilterConfig.suppressDetails === true) {
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Property%20Reimbursement%20Summary%20Report', type);
    } else {
      dataValue.push({ key: 'ShowSummaryRow', value: advanceFilterConfig.summaryRows === true ? 1 : 0 });
      url = GenerateAbsoluteURL(dataValue, advanceFilterConfig.groupBy.selected, 'Property%20Reimbursement%20Report', type);
    }
    downloadReport(
      url,
      'Property Reimbursement Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  // Load master data required to fill filters, using API calls. It will save the data in state.
  loadData() {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 30
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Transition.GetCustomerListingData,
        key: 'legalEntityMasterData',
        fromCache: true,
        duration: 1
      },
      {
        url: API_URL.Report.GetExpenseGroup,
        key: 'expenseGroupMasterData'
      },
      {
        url: API_URL.Report.GetExpenseName,
        key: 'expenseNameMasterData'
      },
      {
        url: API_URL.Report.GetAccountCodeName,
        key: 'accountCodeNameMasterData'
      }
    ])
      .then(
        ({
          employeeMasterData, propertyTypeMasterData, serviceTypeMasterData, propertyMasterData, marketMasterData, clientListingMasterData, legalEntityMasterData, expenseGroupMasterData, expenseNameMasterData, accountCodeNameMasterData
        }) => {
          this._asyncRequest = null;
          if (employeeMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            employeeMasterData: removeDuplicates(employeeMasterData.data, 'employeeName'),
            propertyTypeMasterData: removeDuplicates(propertyTypeMasterData.data, 'propertyTypeName'),
            serviceTypeMasterData: removeDuplicates(serviceTypeMasterData.data, 'serviceType'),
            propertyMasterData: removeDuplicates(propertyMasterData.data, 'propertyName'),
            marketMasterData: removeDuplicates(marketMasterData.data || [], 'marketName'),
            clientListingMasterData: removeDuplicates(clientListingMasterData.data, 'clientName'),
            legalEntityMasterData: removeDuplicates(legalEntityMasterData.data, 'customerName'),
            expenseGroupMasterData: removeDuplicates(expenseGroupMasterData.data, 'expenseGroup'),
            expenseNameMasterData: removeDuplicates(expenseNameMasterData.data, 'expenseName'),
            accountCodeNameMasterData: removeDuplicates(accountCodeNameMasterData.data, 'accountCode'),
            supervisorEmployeeMasterData: removeDuplicates(employeeMasterData.data || [], 'employeeName')
          }, () => {
            if(this.state.isAutoRunEnabled || this.state.isSubmitButtonClicked){
              this.handleSubmit();
            }
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Click event of switch button "Show Single Total". 
  // It will set true/false value to the variable showSingleTotal
  // If the value is true, it will show totals of all selected pay periods
  // If the value is false, it will show pay period wise
  ShowSingleTotal = (checked) => {
    this.setState({ showSingleTotal: checked });
  }

  // Render method to render components based on the conditions
  render() {
    const {
      showMain,
      employeeMasterData,
      propertyMasterData,
      serviceTypeMasterData,
      propertyTypeMasterData,
      marketMasterData,
      legalEntityMasterData,
      propertyReimburseData,
      rows,
      clientListingMasterData,
      expenseGroupMasterData,
      expenseNameMasterData,
      accountCodeNameMasterData,
      showReport,
      openSlidingPanel,
      advanceFilterConfig,
      payPeriodStartDate,
      payPeriodEndDate,
      expand,
      handleCollapse,
      futureEndDate,
      maxEndDate,
      supervisorEmployeeMasterData,
      showTrueUpCredit,
      showSingleTotal
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    if (employeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      employeeMasterData.unshift({ employeeName: 'All' });
    }
    if (propertyTypeMasterData.find(x => x.propertyTypeName === 'All') === undefined) {
      propertyTypeMasterData.unshift({ propertyTypeName: 'All' });
    }
    if (serviceTypeMasterData.find(x => x.serviceType === 'All') === undefined) {
      serviceTypeMasterData.unshift({ serviceType: 'All' });
    }
    if (clientListingMasterData.find(x => x.clientName === 'All') === undefined) {
      clientListingMasterData.unshift({ clientName: 'All' });
    }
    if (legalEntityMasterData.find(x => x.customerName === 'All') === undefined) {
      legalEntityMasterData.unshift({ customerName: 'All' });
    }
    if (expenseGroupMasterData.find(x => x.expenseGroup === 'All') === undefined) {
      expenseGroupMasterData.unshift({ expenseGroup: 'All' });
    }
    if (expenseNameMasterData.find(x => x.expenseName === 'All') === undefined) {
      expenseNameMasterData.unshift({ expenseName: 'All' });
    }
    if (accountCodeNameMasterData.find(x => x.accountCode === 'All') === undefined) {
      accountCodeNameMasterData.unshift({ accountCode: 'All' });
    }
    if (supervisorEmployeeMasterData.find(x => x.employeeName === 'All') === undefined) {
      supervisorEmployeeMasterData.unshift({ employeeName: 'All' });
    }
    return (
      <>
        {showMain
          ? (
            // Show reports list here
            <Reports />
          )
          : (
            // Show Property Reimbursement Report here
            <>              
              <PageHeader
                key={'Property_Reimbursement_Report'}
                title={'Property Reimbursement Report'}
                style={{ marginLeft: '1rem' }}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Property Reimbursement Report
              </PageHeader>
              <Grid container spacing={3} className="no-print row top-xs" style={{ marginLeft: '10px' }}>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      value={this.state.market}
                      onChange={(e, val) => this.handleChange(e, val, 'market', 'marketName')}
                      id="tags-standard"
                      options={marketMasterData} //{removeDuplicates(marketMasterData, 'marketName')}
                      getOptionLabel={(option) => option.marketName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Market"
                        // placeholder="Market"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.property}
                      options={propertyMasterData} // {removeDuplicates(propertyMasterData, 'propertyName')}
                      onChange={(e, val) => this.handleChange(e, val, 'property', 'propertyName')}
                      getOptionLabel={(option) => option.propertyName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Property Name"
                        // placeholder="Property Name"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseName}
                      options={expenseNameMasterData} // {removeDuplicates(expenseNameMasterData, 'expenseName')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseName', 'expenseName')}
                      getOptionLabel={(option) => option.expenseName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.service}
                      options={serviceTypeMasterData} // {removeDuplicates(serviceTypeMasterData, 'serviceType')}
                      getOptionLabel={(option) => option.serviceType}
                      onChange={(e, val) => this.handleChange(e, val, 'service', 'serviceType')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Service Type"
                        // placeholder="Service Type"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.propertyType}
                      options={propertyTypeMasterData} // {removeDuplicates(propertyTypeMasterData, 'propertyTypeName')}
                      getOptionLabel={(option) => option.propertyTypeName}
                      onChange={(e, val) =>
                        this.handleChange(e, val, 'propertyType', 'propertyTypeName')
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Property Type"
                        // placeholder="Property Type"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      blurOnSelect
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.accountCode}
                      options={accountCodeNameMasterData} // {removeDuplicates(accountCodeNameMasterData, 'accountCode')}
                      getOptionLabel={(option) => option.accountCode}
                      onChange={(e, val) =>
                        this.handleChange(e, val, 'accountCode', 'accountCode')
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Account Code Name"
                        // placeholder="Account Code"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.client}
                      options={clientListingMasterData} //{removeDuplicates(clientListingMasterData, 'clientName')}
                      getOptionLabel={(option) => option.clientName}
                      onChange={(e, val) => this.handleChange(e, val, 'client', 'clientName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Client"
                        // placeholder="Client"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.employee}
                      options={employeeMasterData} // {removeDuplicates(employeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => this.handleChange(e, val, 'employee', 'employeeName')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Employee Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      value={this.state.SupervisorEmployee || ''}
                      options={supervisorEmployeeMasterData} // {removeDuplicates(supervisorEmployeeMasterData, 'employeeName')}
                      getOptionLabel={(option) => option.employeeName}
                      onChange={(e, val) => {
                        this.handleChange(e, val, 'SupervisorEmployee', 'employeeName');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Supervisor Name"
                        // placeholder="Employee Name"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2} >
                  <Grid item xs={12} >
                    <Autocomplete
                      multiple
                      limitTags={1}
                      blurOnSelect
                      id="tags-standard"
                      options={legalEntityMasterData} // {removeDuplicates(legalEntityMasterData, 'customerName')}
                      value={this.state.legalEntity}
                      getOptionLabel={(option) => option.customerName}
                      onChange={(e, val) =>
                        this.handleChange(e, val, 'legalEntity', 'customerName')
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Legal Entity"                        
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      blurOnSelect
                      multiple
                      limitTags={1}
                      id="tags-standard"
                      value={this.state.expenseGroup}
                      options={removeDuplicates(expenseGroupMasterData, 'expenseGroup')}
                      onChange={(e, val) => this.handleChange(e, val, 'expenseGroup', 'expenseGroup')}
                      getOptionLabel={(option) => option.expenseGroup}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Expense Group"
                        // placeholder="Expense Group"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid style={{ marginTop: '10px' }}>
                      <Switch
                        isChecked={showTrueUpCredit}
                        onChangeValues={(checked, key) => {
                          this.isAcceptCondition(checked);
                        }}
                        id={'switch-trueup_credit_records_id'}
                        labelText={'Show Detailed TrueUp/Credit Records'}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} lg={2}>
                  <Grid item xs={12} style={{ marginTop: '8px' }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container justify="space-around" >
                      <KeyboardDatePicker
                        marginTop='10px !important'
                        // margin="normal"
                        id="date-picker-dialog"
                        label="Pay Period(From)"
                        format="MM/dd/yyyy"
                        // maxDate={maxEndDate} // {payPeriodEndDate}
                        value={payPeriodStartDate}
                        name={'payPeriodStartDate'}
                        onChange={(e) =>
                          this.handleDateChange(e, 'payPeriodStartDate')
                        }
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        shouldDisableDate={this.disableDatesForPayCycleStart}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: '8px' }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        // margin="normal"
                        marginTop='10px !important'
                        id="date-picker-dialog"
                        label="Pay Period(To)"
                        format="MM/dd/yyyy"
                        minDate={payPeriodStartDate}
                        maxDate={futureEndDate}
                        value={payPeriodEndDate}
                        name={'payPeriodEndDate'}
                        onChange={(e) =>
                          this.handleDateChange(e, 'payPeriodEndDate')
                        }
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        shouldDisableDate={this.disableDatesForPayCycleEnd}
                        maxDateMessage= {'Please select date within '+this.state.noOfAllowedPayPeriodsForReports+' Pay Periods'}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider> 
                  </Grid>
                    <Grid style={{ marginTop: '10px', marginLeft: '16px' }}>
                      <Switch
                        isChecked={showSingleTotal}
                        onChangeValues={(checked, key) => {
                          this.ShowSingleTotal(checked);
                        }}
                        id={'switch_show_single_total_id'}
                        labelText={'Show Single Total'}
                        fullWidth                        
                      />
                    </Grid>
                </Grid>
                <ReportButtons
                  resetPage={this.resetPage}
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.handleExport}
                  data={propertyReimburseData}                  
                />
              </Grid>
              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    payPeriodStartDate={this.state.payPeriodStartDate}
                    payPeriodEndDate={this.state.payPeriodEndDate}
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              {showReport &&
                propertyReimburseData !== null &&
                propertyReimburseData.length > 0 && rows.length > 0 && (
                  // <TableContainer
                  //   component={Paper}
                  //   style={{ maxWidth: '100vw' }}
                  // >
                  //   {this.renderTable(propertyReimburseData)}
                  // </TableContainer>
                  <TableWithPaginations
                    tableData={rows} // {propertyReimburseData}
                    renderTable={this.renderTable}
                    expand={expand}
                    order={this.state.order}
                    oBy={this.state.orderBy}
                    handleCollapse={handleCollapse}
                  />
                )}
              <ConfirmDialog
                IsOpen={this.state.openDialog}
                Title={this.state.dialogTitle}
                Message={this.state.confirmationMessage}
                OnHandelClick={(isValid) => {
                  if (isValid) {
                    this.onConfirmClickHandle(isValid);
                  } else {
                    this.onConfirmClickHandle(isValid);
                  }
                }}
                AgreeText="Yes"
                DisAgreeText="No"
              />
              {/* If Auto Run is not enabled and buttons not clicked, then show message to click button */}
              {(this.state.isAutoRunEnabled === false && this.state.isSubmitButtonClicked === false) && 
                (propertyReimburseData === null || propertyReimburseData.length <= 0) && (
                  <PageLandingMessage/>
                )
              }
              {/* If no data is found then show then message */}
              {showReport // && (propertyReimburseData == null || propertyReimburseData.length <= 0) 
                && rows.length <= 0 && (
                  <Grid container spacing={4}>
                    <Grid
                      container
                      direction="row-reverse"
                      justify="center"
                      alignItems="stretch"
                    >
                      <label className="item-big"> { this.state.downloadMessage !== null ? this.state.downloadMessage : 'No Data Available.' } </label>
                    </Grid>
                  </Grid>
                )}
            </>
          )}
      </>
    );
  }
}